import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';


const NetworksList = ({selectedNetworkName, networks, onNetworkChange}) => {

  const handleChangeNetwork = (event) => {
    let networkName = event.target.value;
    onNetworkChange(networkName);
  };

  return (
    <>
    <InputLabel id="select-network-label">Network</InputLabel>
    <Select
      labelId="selectNetwork"
      id="select-network"
      defaultValue={selectedNetworkName}
      onChange={handleChangeNetwork}
    >
      {networks.map(network =>
        <MenuItem value={network.bsc_name} key={network.bsc_name}>{network.title}</MenuItem>
      )}
    </Select>
    </>
  );
};

export default NetworksList;